<div class="avatar {{classes}}" [class.no-letter]="!image && !loading && !name" [ngStyle]="getImage(image)">

    <div class="letter" [class.editable]="editable" *ngIf="!image && !loading">
        {{ name?.charAt(0) }}
    </div>

    <label class="upload" *ngIf="!loading && editable">
        <input style="display:none" type="file" class="custom-file-input" ng2FileSelect [uploader]="uploader" />
        <span>
            <i class="material-icons">cloud_upload</i>
        </span>
    </label>

    <div class="loader" *ngIf="loading">
        <app-loader></app-loader>
    </div>

</div>

<p class="text-small clickable" *ngIf="editable && image && !loading" (click)="removeImage()">{{ 'GENERAL.remove' | translate }}</p>
<label class="text-small clickable" *ngIf="editable && !image && !loading">
    <input style="display:none" type="file" class="custom-file-input" ng2FileSelect [uploader]="uploader" />
    <p>
        {{ 'GENERAL.edit' | translate }}
    </p>
</label>